import React, {useState} from 'react';
import cx from 'classnames';

import {Box, useFocusFromOpened, useModal} from '@pexip/components';

import {TestId} from '../../../test/testIds';
import {useShouldPanelBeModal} from '../../hooks/useShouldPanelBeModal';

import styles from './ParticipantSidePanelWrapper.module.scss';

export const ParticipantSidePanelWrapper: React.FC<{
    children: React.ReactNode;
    isOpen: boolean;
    animateIn: boolean;
    animateOut: boolean;
    isNetworkAlertDisplayed: boolean;
}> = ({children, isOpen, animateIn, animateOut, isNetworkAlertDisplayed}) => {
    const [boxElement, setBoxElement] = useState<HTMLDivElement | null>(null);
    useFocusFromOpened(boxElement, isOpen);

    const shouldEnableModal = useShouldPanelBeModal(isOpen);
    const {ref} = useModal(shouldEnableModal);

    return (
        <div ref={ref}>
            <Box
                ref={setBoxElement}
                className={cx(styles.panel, styles.participantList, {
                    [styles.show]: isOpen,
                    [styles.animateIn]: animateIn,
                    [styles.animateOut]: animateOut,
                    [styles.networkAlert]: isNetworkAlertDisplayed,
                })}
                data-testid={TestId.ParticipantPanel}
            >
                {children}
            </Box>
        </div>
    );
};

export type ParticipantSidePanelWrapperProps = React.ComponentProps<
    typeof ParticipantSidePanelWrapper
>;
